export default "__VITE_PUBLIC_ASSET__adde2ff0__"